{
    "title": {
        "registered": "Company Registered Address",
        "physical": "Company Physical Address"
    },
    "input":{
        "country": "Country",
        "state": "State",
        "city": "City",
        "addressLine1": "Address Line 1",
        "addressLine2": "Address Line 2",
        "addressLine3": "Address Line 3",
        "postalCode": "Postal Code",
        "unitNumber": "Unit Number"
    },
    "option": {
        "yes": "Yes",
        "no": "No"
    },
    "advice": "The company registered address is the same as the physical address"
}